export const BIKES24_SIDEBAR_LIST = {
  data_collection: [
    {
      icon: "/sidebarIcon/award.svg",
      label: "Whatsapp Template",
      link: "/dashboard/user-notification/whatsapp-template",
    },
    {
      icon: "/sidebarIcon/award.svg",
      label: "Communication Template",
      link: "/dashboard/user-notification/communication-template",
    },
  ],
};
